<template>
	<div class="footer">
		<div class="footer_c">
			<div class="footer_c_1">
				<h1 class="logo">
					红匣子游戏
				</h1>
			</div>
			<div class="footer_c_2">
				<ul>
					<li><a href="http://www.cubeverse.games/">{{ langConfig.footNav[0] }}</a></li>|
					<li><a href="http://www.cubeverse.games/">{{ langConfig.footNav[1] }}</a></li>|
					<li><a href="http://www.cubeverse.games/">{{ langConfig.footNav[2] }}</a></li>|
					<li><a :href="langConfig.footLink1" target="_blank">{{ langConfig.footNav[3] }}</a></li>|
					<li><a :href="langConfig.footLink2" target="_blank">{{ langConfig.footNav[4] }}</a></li>
				</ul>
				<p>
					{{ langConfig.footInfo }}<a href="https://beian.miit.gov.cn" target="_blank" style="margin-left: 6rem;">{{ langConfig.footIcp }}</a><br>
					{{ langConfig.footName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ langConfig.footAddress }}<br>
					{{ langConfig.footEmail2 }} <img src="../../assets/imgs/email.png"/>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import langzhcn from '../../pages/pc/config/zh-cn.json';

export default {
    name: "Footer",
		props: {
			lang : {
				type: String,
				default: "zh-cn"
			}
    },
		data () {
			return {
				langConfig: langzhcn
			};
    },
		mounted() {
			console.log('foot-lang', this.lang)
    }
};
</script>

<style scoped lang="scss">
// .footer {
// 	width: 100%;
// 	height: 248px;
// 	overflow: hidden;
// 	background: url("../../assets/imgs/bg_8.jpg") no-repeat center;
// 	background-size: 100% auto;
// 	.footer_c{
// 		width: 1100px;
// 		height: 200px;
// 		margin: 40px auto 0 auto;
// 		display: flex;
// 		justify-content: space-between;
// 		&_1{
// 			.logo{
// 				width: 210px;
// 				height: 73px;
// 				margin: 10px 0 0 12px;
// 				background: url("../../assets/imgs/logo.png") no-repeat top left;
// 				background-size: 180px auto;
// 				overflow: hidden;
// 				text-indent: 9999rem;
// 				line-height: 9999px;
// 			}
// 		}
// 		&_2{
// 			width: 760px;
// 			height: 180px;
// 			ul{
// 			width: 760px;
// 			height: 72px;
// 			font-size: 22px;
// 			color: #515151;
// 			display: flex;
// 			justify-content: space-between;
// 			line-height: 82px;
// 			margin: 0 0 0 26px;
// 				li{
// 					a{
// 						color: #515151;
// 						&:hover{
// 							color: #000;
// 						}
// 					}
// 				}
// 			}
// 			p{
// 				margin: 3px 0 0 30px;
// 				line-height: 28px;
// 				color: #2b2b2b;
// 				font-size: 16px;
// 				text-align: left;
// 			}
// 		}
// 	}
// }

</style>
